"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESERVATION_STATUS = void 0;
var RESERVATION_STATUS;
(function (RESERVATION_STATUS) {
    RESERVATION_STATUS["ARRIVED"] = "ARRIVED";
    RESERVATION_STATUS["PARTIALLY_ARRIVED"] = "PARTIALLY_ARRIVED";
    RESERVATION_STATUS["PRE_ARRIVED"] = "PRE_ARRIVED";
    RESERVATION_STATUS["PRE_PARTIALLY_ARRIVED"] = "PRE_PARTIALLY_ARRIVED";
    RESERVATION_STATUS["NOT_RECONCILED"] = "NOT_RECONCILED";
    RESERVATION_STATUS["CONFIRMED"] = "CONFIRMED";
    RESERVATION_STATUS["BOOKED"] = "BOOKED";
    RESERVATION_STATUS["SEATED"] = "SEATED";
    RESERVATION_STATUS["ORDER_PLACED"] = "ORDER_PLACED";
    RESERVATION_STATUS["CHECK_DROPPED"] = "CHECK_DROPPED";
})(RESERVATION_STATUS = exports.RESERVATION_STATUS || (exports.RESERVATION_STATUS = {}));
//# sourceMappingURL=reservations.js.map